<div class="cald_dialog" #productDataTableDialog>
  <div class="cald_header">
    <button class="close-dialog-button sap-icon" data-dismiss="modal" (click)="cancel()">&#xe03e;</button>
    <h2>{{'Admin.AddEditUserType.SelectProduct'| translate}}</h2>
  </div>
  <div class="cald_content" style="padding-top: 20px;">
    <cpq-datatable [service]='service' [columns]="columns" (onRowsChanged)='onRowsChanged($event)'
    [filter]='filter' (onRowChanged)='onRowChanged($event)' [scrollbarH]="'true'"  class="product-datatable" [guid]="guid"></cpq-datatable>

    <ng-template #selectTmpl let-column="column" let-row='row'>
      <button type="button" class="btn btn-secondary fiori3-btn-secondary" (click)="save(row)">
        {{'Admin.Msg.SelectButton' | translate}}
      </button>
    </ng-template>
  </div>

  <div class="form-inline cald_dialog_buttonbar">
    @if (productDataTableData && productDataTableData.isMultiSelect) {
      <button type="button" class="btn btn-primary fiori3-btn-primary" tabindex="-1" (click)="save()">{{'Admin.Msg.Save'
      | translate}}</button>
    }
    <button id="cancelReplacementProductDialog" class="btn btn-tertiary fiori3-btn-tertiary" tabindex="-1" (click)="cancel()">{{'Msg.Cancel' | translate}}</button>
  </div>
</div>
